const API_KEY_STORAGE_KEY = 'apiKey';

export const getApiKey = () => localStorage.getItem(API_KEY_STORAGE_KEY);

export const setApiKey = (key: string) => localStorage.setItem(API_KEY_STORAGE_KEY, key);

export const clearApiKey = () => localStorage.removeItem(API_KEY_STORAGE_KEY);
